import react, {useEffect, useMemo} from 'react';
import MyTable from '../components/myTable';
import {useSelector} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookie from 'react-cookies';
import { FaPlus } from 'react-icons/fa';
import { userList } from '../../api/api';

const Users = () => {
    // const marginLeft = useSelector(state => state.style.payload.marginLeft)
    const navigate = useNavigate();
    const data = useSelector(state => state.members.members);
    
   
    const getUsers = async () => {
        window.start_load();
        const res = await userList({token:Cookie.load('token')});
        // if(!res.succes)
        window.stop_load();
    }
    const columns = useMemo( () => [
        {
            Header: '#',
            accessor: (data, i) => {
                return (i+1)
            }
        },
        {
            Header: 'Photo',
            accessor: ((user) => (
                <img src={user.img} height={50} width={50} />
            ))
        },
        {
            Header: 'name',
            accessor: 'name',
        },
        {
            Header: 'Email',
            accessor: 'email'
        },
        {
            Header: 'Phone',
            accessor: 'phone'
        },
        {
            Header: 'Position',
            accessor: 'position'
        },
        {
            Header: 'Action',
            accessor: (data) => 
                (
                    <button className="form-control btn-sm btn-color"
                    style={{ 
                        fontSize: 12
                     }}
                    onClick={() => {
                        Cookie.save('editData', JSON.stringify(data));
                        navigate("/member_details")}}
                    >
                        View
                    </button>
                )
            
        }
    ], [])

    useEffect(() => {
        document.title = 'BSC Members | Bida Sport Club'
        data.length == 0 && getUsers();
    }, [])
    return data.length > 0 ? (
        <div className=''> 
            {/* <h2> Users </h2> */}
            <MyTable data ={data} columns={columns} pageName = {"BSC Members"}
             button = {<button className='btn btn-md btn-color'
             style={{ 
                 // width:'170px',
                 height: '40px'
              }}
             onClick={()=> navigate('/new_member')}
             > <FaPlus /> New Member </button>}
            />
        </div>
    ):
    (
        <div className=' row justify-content-center py-5'>
            <h4> <b className="mb-5 ms-5">User List</b> </h4>
            <h3> <p className="mb-5 ms-5 text-center">User List is Empty.</p> </h3>
        </div>
    )
}

export default Users